exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".body .repeat-title[data-v-7df8c7be]{font-size:13px;font-weight:bold}.body .repeat-left[data-v-7df8c7be]{font-size:13px}.body p[data-v-7df8c7be]{margin:15px 0 6px 0;font-size:13px}.dialog-footer[data-v-7df8c7be]{padding-top:20px;border-top:1px solid #e6ebf5}\n", ""]);

// exports
